import { render, staticRenderFns } from "./FleetDashboard.vue?vue&type=template&id=f072c830&scoped=true"
import script from "./FleetDashboard.vue?vue&type=script&lang=js"
export * from "./FleetDashboard.vue?vue&type=script&lang=js"
import style0 from "./FleetDashboard.vue?vue&type=style&index=0&id=f072c830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f072c830",
  null
  
)

export default component.exports